import { render, staticRenderFns } from "./OrderInfoSubItem.vue?vue&type=template&id=12f45466&scoped=true"
import script from "./OrderInfoSubItem.vue?vue&type=script&lang=js"
export * from "./OrderInfoSubItem.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoSubItem.vue?vue&type=style&index=0&id=12f45466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f45466",
  null
  
)

export default component.exports